import { Currency } from 'ha/constants/Currencies';

interface AllOptions extends Intl.NumberFormatOptions {
  localeMatcher?: 'lookup' | 'best fit';
  currencyDisplay?: 'code' | 'symbol' | 'name';
}
type NumberFormatOptions = Omit<AllOptions, 'style'>;

export default (locale: string) => (
  amount: number,
  currency: Currency,
  config?: NumberFormatOptions,
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currencyDisplay: 'code',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...config,
  }).format(amount / 100);
};
